import { z } from "zod";

/*
 * Based on PaymentMethods.d.ts interface Cards - brand
 * Documendation: https://stripe.com/docs/api/errors?lang=node#errors-payment_method-card-brand
 */
export const CardBrand = z.enum([
    "amex",
    "diners",
    "discover",
    "eftpos_au",
    "jcb",
    "mastercard",
    "unionpay",
    "visa",
    "unknown",
]);

export type CardBrand = z.infer<typeof CardBrand>;

export type CardPaymentMethod = {
    id: string;
    brand: CardBrand;
    last4: string;
    expMonth: number;
    expYear: number;
};

export type PaymentCustomer = {
    id: string;
    email: string | null;
    name: string | null | undefined;
    currency: string | null | undefined;
};

/*
 * Supported card brands: https://stripe.com/docs/payments/cards/supported-card-brands
 */
export const brandToTextMap: Record<CardBrand, string> = {
    amex: "American Express",
    diners: "Diners Club",
    discover: "Discover",
    eftpos_au: "eftpos Australia",
    jcb: "Japan Credit Bureau",
    visa: "Visa",
    mastercard: "Mastercard",
    unionpay: "China UnionPay",
    unknown: "Unknown",
};
